import { Injectable, LOCALE_ID, Optional, Inject } from '@angular/core';
import { LanguageMessage, LanguageMessageFactory } from './languages/index';


/**
 * å¤è¯­è¨æå¡
 * @scope FormModule
 */
@Injectable()
class LanguageService implements LanguageMessage {

  /**
   * åä¾å¯¹è±¡
   */
  private static innerInstance: LanguageService = null;

  // #region å®ç°LanguageMessageæ¥å£ï¼æ¹ä¾¿ä¹¦å
  public yes: string;
  public no: string;
  public unsaveNotifyTitle: string;
  public clientNotifyTitle: string;
  public serverNotifyTitle: string;
  public cancelApproveSuccess: string;
  public cancelApproveFailed: string;
  public unallowEmptyProcessInstanceName: string;
  public unallowEmptyBizBillId: string;
  public unallowEmptyChildBizBillId: string;
  public bizDefKeyRequired: string;
  public procInsIdRequired: string;
  public addChildFailed: string;
  public addSiblingFailed: string;
  public addSubChildFailed: string;
  public addSubSiblingFailed: string;
  public deleteFailed: string;
  public multiSaveFailed: string;
  public appendFailed: string;
  public queryFailed: string;
  public cancelFailed: string;
  public updateFailed: string;
  public addFailed: string;
  public loadFailed: string;
  public saveSuccess: string;
  public saveFailed: string;
  public deleteSuccess: string;
  public deleteFaild: string;
  public confirmDeletion: string;
  public submitSuccess: string;
  public submitFaild: string;
  public notifyTitle: string;
  public httpError: string;
  public gridDataNotSave: string;
  public exitWithoutSave: string;
  public notSupportMenuType: string;
  public cancelWithoutSave: string;
  public plsSelectDeleteData: string;
  public errorHierarchyKey: string;
  public plsSelectParentNode: string;
  public deleteChildFirst: string;
  public incorrectHierarchyConfig: string;
  public operationFailed: string;
  public plsSelectEditData: string;
  public plsSelectViewData: string;
  public plsUploadFirst: string;
  public defaultDialogTitle: string;
  public changeToFirst: string;
  public changeToLast: string;
  public noProcessInstanceId: string;
  public noDataExist: string;
  public noAttachment: string;
  public confirm: string;
  public cancel: string;
  public plsSelectCopyData: string;
  public copyFieldsRequired: string;
  public pathIsRequired: string;
  public propsIsEmpty: string;
  public historyAttachment: string;
  public plsSelectDownloadAtt: string;
  public noDownloadAtt: string;
  public plsCheckBatchEditRows: string;
  public plsSelectDetailFormData: string;
  public dataAndStateChanged: string;
  public dataChanged: string;
  public stateChanged: string;
  public defaultStateName: string;
  public copy: string;
  public copySuccess: string;
  public copyFailed: string;
  public roger: string;
  public appOrFuncIdRequired: string;
  public tableCanNotEmpty: string;
  public plsSelectRemoveAtt: string;
  public plsSelectUpdateRow: string;
  public hasChangeCheckFaild: string;
  public noParentData:string;
  // #endregion

  /**
   * å½åè¯­è¨
   */
  protected language = 'zh-CHS';

  /**
   * å½åè¯­è¨å
   */
  protected get languageMessage(): LanguageMessage {
    return LanguageMessageFactory.create(this.language);
  }

  /**
   * æé å½æ°
   */
  constructor(@Optional() @Inject(LOCALE_ID) localeId?: string) {
    this.language = localeId || 'zh-CHS';
    this.extendProperties();
    LanguageService.innerInstance = this;
  }

  /**
   * è·åå®ä¾
   */
  public static getInstance() {
    if (this.innerInstance) {
      return this.innerInstance;
    }
    const instance = new LanguageService('zh-CHS');
    LanguageService.innerInstance = instance;
    return instance;
  }

  /**
   * æ©å±å±æ§
   */
  private extendProperties() {
    Object.keys(this.languageMessage).forEach((propName: string) => {
      Object.defineProperty(this, propName, {
        get: () => {
          return this.languageMessage[propName];
        }
      });
    });
  }
}

export { LanguageService };
